import { EntityModel } from '@/interfaces'
import {
  ALL_DIVIDER_BLOCKS_QUERY,
  CREATE_DIVIDER_BLOCK_MUTATION,
  DELETE_DIVIDER_BLOCK_MUTATION,
  FORCE_DELETE_DIVIDER_BLOCK_MUTATION,
  SINGLE_DIVIDER_BLOCK_QUERY,
  UPDATE_DIVIDER_BLOCK_MUTATION,
} from './graphql'

const cmsDividerBlockModel: EntityModel = {
  name: 'dividerBlock',
  namePlural: 'dividerBlocks',
  uniqueName: 'cmsDividerBlock',
  uniqueNamePlural: 'cmsDividerBlocks',
  path: 'cms/blocks/divider_block',
  baseUrl: '/cms/blocks/divider_blocks',
  translationPrefix: 'entities:cmsDividerBlock.',
  getDisplayName: (values: any) => {
    return 'Divider Block'
  },
  gql: {
    getAll: ALL_DIVIDER_BLOCKS_QUERY,
    getSingle: SINGLE_DIVIDER_BLOCK_QUERY,
    create: CREATE_DIVIDER_BLOCK_MUTATION,
    update: UPDATE_DIVIDER_BLOCK_MUTATION,
    delete: DELETE_DIVIDER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_DIVIDER_BLOCK_MUTATION,
  },
  attributes: {
    fluid: {
      name: 'fluid',
      label: 'entities:cmsDividerBlock.attributes.fluid.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsDividerBlockModel
